import axios from 'axios'
import qs from "qs"
// 创建axios实例
const service = axios.create({
    withCredentials: true,
    baseURL: process.env.BASE_API, // api的base_url
    timeout: 150000000 // 请求超时时间
})
let cookieInfo = {}
// request拦截器
service.interceptors.request.use(config => {
    if (config.method === "post") {
        config.data = qs.stringify(config.data);
    }
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (!res.isSuccessed) {
            Promise.reject('error')
            return response.data;
        } else {
            return response.data
        }
    },
    error => {
        return Promise.reject(error)
    }
)
export default service